module.exports = __webpack_public_path__ + "media/images/x-golf-logo-9274458637904269b27262fc5981360a.png";